import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NotesEffects } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.effects';
import { notesReducer } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.reducers';
import { notesFeatureKey } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(notesFeatureKey, notesReducer),
        EffectsModule.forFeature([NotesEffects])
    ]
})
export class NotesStoreModule {}
